export const SIDE_NAV_WIDTH = { sm: 220, md: 260, lg: 300 };
